// theme/createMuiTheme.js
import { createTheme, alpha, darken } from '@mui/material/styles';
import { useCustomTheme } from '../../app/hooks/useCustomTheme';

export const useMuiTheme = () => {
    const style = useCustomTheme();

    const primaryBtnBg = style.custom.button.primary.bgColor;
    const primaryBtnColor = style.custom.button.primary.color;
    const secondaryBtnBg = style.custom.button.secondary.bgColor;
    const secondaryBtnColor = style.custom.button.secondary.color;

    const primaryTabBg = style.custom.tab.primary.bgColor;
    const primaryTabColor = style.custom.tab.primary.color;
    const secondaryTabBg = style.custom.tab.secondary.bgColor;
    const secondaryTabColor = style.custom.tab.secondary.color;

    const redeemBgColor = style.custom.redeem.bgColor;
    const redeemColor = style.custom.redeem.color;

    const muiTheme = createTheme({
        typography: {
            fontFamily: "'Sarabun', 'Poppins', Helvetica, sans-serif",
            fontSize: 14,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        '&.Mui-disabled': {
                            backgroundColor: '#E0E0E0',
                            color: '#9E9E9E',
                            borderColor: '#E0E0E0',
                            boxShadow: 'none',
                            pointerEvents: 'none',
                        },
                    },
                },
                variants: [
                    {
                        props: { variant: 'contained', color: 'main' },
                        style: {
                            backgroundColor: primaryBtnBg,
                            color: primaryBtnColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: darken(primaryBtnBg, 0.1),
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { variant: 'contained', color: 'secondary' },
                        style: {
                            backgroundColor: secondaryBtnBg,
                            color: secondaryBtnColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: darken(secondaryBtnBg, 0.1),
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { variant: 'outlined', color: 'main' },
                        style: {
                            border: `2px solid ${primaryBtnBg}`,
                            color: primaryBtnColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            backgroundColor: 'transparent',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: alpha(primaryBtnBg, 0.08),
                                borderColor: darken(primaryBtnBg, 0.1),
                            },
                        },
                    },
                    {
                        props: { variant: 'outlined', color: 'secondary' },
                        style: {
                            border: `2px solid ${secondaryBtnBg}`,
                            color: secondaryBtnColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            backgroundColor: 'transparent',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: alpha(secondaryBtnBg, 0.08),
                                borderColor: darken(secondaryBtnBg, 0.1),
                            },
                        },
                    },
                    {
                        props: { type: 'tab', color: 'main' },
                        style: {
                            backgroundColor: primaryTabBg,
                            color: primaryTabColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: darken(primaryTabBg, 0.1),
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { type: 'tab', color: 'secondary' },
                        style: {
                            backgroundColor: secondaryTabBg,
                            color: secondaryTabColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: darken(secondaryTabBg, 0.1),
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { variant: 'contained', type: 'redeem', },
                        style: {
                            backgroundColor: redeemBgColor,
                            color: redeemColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            boxShadow: 'none',
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: darken(redeemBgColor, 0.1),
                                boxShadow: 'none',
                            },
                        },
                    },
                    {
                        props: { variant: 'outlined', type: 'redeem' },
                        style: {
                            border: `2px solid ${redeemBgColor}`,
                            color: redeemColor,
                            textTransform: 'none',
                            fontSize: '1rem',
                            borderRadius: '6px',
                            backgroundColor: 'transparent',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: alpha(redeemBgColor, 0.08),
                                borderColor: darken(redeemBgColor, 0.1),
                            },
                        },
                    },
                ],
            },
        },
    });


    return muiTheme;
};
